<template>
  <div class="flex items-center bg-gray-100 px-4 pb-6 pt-2 rounded-lg">
    <span
      class="mx-2 inline-flex items-center justify-center size-[46px] rounded-full bg-gray-500 text-lg font-semibold text-white leading-none">
      {{ getIniciales(paciente.copnNombre1, paciente.copnApellido1) }}
    </span>
    <div class="mt-4">
      <span class="text-blue-600">{{ paciente.copnNombre1 }} {{ paciente.copnApellido1 }} </span>
      <br><span class="dark:text-white"> {{ paciente.tipoidentificacion?.comaNombrecorto }}
        {{ paciente.copeIdentificacion }} - {{ paciente.copeTelefono }}</span>
      <br><span v-if="paciente.coppFechanacimiento" class="text-blue-600 text-xs uppercase ">{{ paciente.sexo?.comaNombrelargo ?? '' }} de
        {{ calcularEdad(paciente.coppFechanacimiento) ?? '' }}</span>
      <br><span class="dark:text-white text-xs">{{ paciente.departamento?.comaNombrelargo ?? '' }}-{{
        paciente.municipio?.comaNombrelargo ?? '' }} {{ paciente.coppTipoBarrio ?? '' }} {{
          paciente.copeDireccion ?? '' }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getIniciales, calcularEdad } from '@/modules/Core/usings/generales'
import type { PropType } from 'vue'
import type { IConfPersonasPaciente } from '@/modules/Administracion/interfaces'

const props = defineProps({
  paciente: {
    type: Object as PropType<IConfPersonasPaciente>,
    required: true,
  }
})
const { paciente } = props
</script>
